module.exports = __webpack_public_path__ + "img/lengshui.851002c6.png";